import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const SQUARE_BOOKING_URL =
  "https://book.squareup.com/appointments/lwb8mmm1dxweu3/location/LZKNM6MX13R6H/services";

export const openSquareBooking = () =>
  window.open(SQUARE_BOOKING_URL, "_blank", "noopener,noreferrer");

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const IMAGES = {
  heroBg: "https://images.unsplash.com/photo-1585747860715-2ba37e788b70",
  servicesBg: "https://images.unsplash.com/photo-1599351431202-1e0f0137899a",
  shave: "https://images.pexels.com/photos/12302334/pexels-photo-12302334.jpeg",
  haircut: "https://images.pexels.com/photos/4625626/pexels-photo-4625626.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  beard: "https://images.pexels.com/photos/9153970/pexels-photo-9153970.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  tools: "https://images.pexels.com/photos/7518717/pexels-photo-7518717.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
};
